/* section-search.js — extracted from sections/search.liquid */
(function () {
    function initSearchControls() {
      var select = document.querySelector('[data-search-sort]');
      if (!select || select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    document.addEventListener('DOMContentLoaded', initSearchControls);
    document.addEventListener('shopify:section:load', initSearchControls);
    initSearchControls();
  })();
